import Events from '@/scripts/lib/Events';
import { debounce } from 'throttle-debounce';
import HeaderMenuItem from './HeaderMenuItem';

/** @param {HTMLElement} header */
export default class HeaderMenu {
   events = new Events();

   _animationFrame = 0;
   _containerWidth = 0;
   _totalItemsWith = 0;

   /** 
    * @param {HTMLElement} root 
    * @param {HTMLElement} container
    */
   constructor(root, container) {
      this.$root = root;
      this.$container = container;

      this._init();
   }

   _init() {
      this._getElements();
      this._initItems();
      this.update();

      this._initEvents();
      this._ready();
   }

   update() {
      this._updateMetrics();
      this._recalculate();
      this.events.emit('update');
   }

   _recalculate() {
      const { _containerWidth: cw, _totalItemsWith, items, moreItem } = this;

      const showMore = _totalItemsWith >= cw;
      const maxWidth = (showMore) ? cw - moreItem.width : cw;

      items.reduce((width, item) => {
         width += item.width;
         item.setVisibility(width <= maxWidth);
         return width;
      }, 0);

      moreItem.setVisibility(showMore);
   }

   _updateMetrics() {
      this._containerWidth = this.$container.getBoundingClientRect().width;

      this.moreItem.updateMetrics();
      this.items.forEach(item => item.updateMetrics());

      this._totalItemsWith = this.items
         .reduce((total, { width }) => total + width, 0);
   }

   _initEvents() {
      window.addEventListener('orientationchange', () => {
         requestAnimationFrame(() => this.update());
      });

      let resizing = false;
      window.addEventListener('resize', () => {
         if (resizing === true) return;
         resizing = true;

         this._startResizing();
      });

      window.addEventListener('resize', debounce(200, () => {
         resizing = false;
         this._stopResizing();
      }));
   }

   _startResizing() {
      this._animationFrame = requestAnimationFrame(function tik() {
         this._tik();
         this._animationFrame = requestAnimationFrame(tik.bind(this));
      }.bind(this));
   }

   _stopResizing() {
      cancelAnimationFrame(this._animationFrame);
   }

   _tik() {
      this.update();
   }

   _initItems() {
      this.items = this.$items.map($item => new HeaderMenuItem($item));
      this.moreItem = new HeaderMenuItem(this.$more);
   }

   _ready() {
      this.$root.classList.add('header-menu__ready');
   }

   _getElements() {
      this.$more = this.$root.querySelector('.menu-more-item-js');
      this.$items = [...this.$root.querySelectorAll('.menu-item-js')];
   }
}